import { withStylePrefix } from '../common/withStylePrefix';
import { SnackbarComponent, snackbarTemplate } from './Snackbar';
import styles from './Snackbar.styles.scss';
export const snackbarDefinition = {
    baseName: 'snackbar',
    template: snackbarTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonSnackbar = SnackbarComponent.compose(snackbarDefinition);
